import { render, staticRenderFns } from "./ListViewSubscriptions.vue?vue&type=template&id=55f25996&scoped=true&"
import script from "./ListViewSubscriptions.vue?vue&type=script&lang=js&"
export * from "./ListViewSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./ListViewSubscriptions.vue?vue&type=style&index=0&id=55f25996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f25996",
  null
  
)

export default component.exports